import React from "react";
import { Button } from "@aidkitorg/component-library";
import { MetricFormFields } from "./MetricFormFields";
import { CreateComponentProps } from "./CreateDashboardComponentTab";
import { useDashboards } from "../../../Contexts/DashboardsContext";
import { createStagedComponent } from "@aidkitorg/types/lib/admin-panel/dashboard";
import { useMetricFormState } from "../hooks/useMetricFormState";
import { useLocalizedStrings } from "../../../Localization";

export const MetricComponentConfig: React.FC<CreateComponentProps> = ({ setDisplayMode, onClose }) => {
  const L = useLocalizedStrings()
  const {
    title, setTitle,
    description, setDescription,
    metricType, setMetricType,
    aggregation, setAggregation,
    dataField, setDataField,
    numeratorAggregation, setNumeratorAggregation,
    numerator, setNumerator,
    denominatorAggregation, setDenominatorAggregation,
    denominator, setDenominator,
    decimalPlaces, setDecimalPlaces,
    filterConfig, setFilterConfig,
    buildMetricObject,
    isFormStateValid
  } = useMetricFormState()

  const { setStagedComponents, getDashboardComponentTranslation } = useDashboards();

  const saveMetricComponent = async () => {
    const newMetric = buildMetricObject();

    const translations = await getDashboardComponentTranslation(newMetric);
    if (translations && translations.success) {
      const stagedComponent = createStagedComponent(newMetric, translations.data);
      setStagedComponents(prev => [...prev, stagedComponent]);
      setDisplayMode('create');
      onClose?.();
    } else {
      console.error("Failed to translate metric component:", newMetric);
      // TODO: Add user-facing error message
    }
  };

  return (
    <div className="flex flex-col gap-y-2">
      <MetricFormFields
        title={title}
        setTitle={setTitle}
        metricType={metricType}
        setMetricType={setMetricType}
        aggregation={aggregation}
        setAggregation={setAggregation}
        dataField={dataField}
        setDataField={setDataField}
        numeratorAggregation={numeratorAggregation}
        setNumeratorAggregation={setNumeratorAggregation}
        numerator={numerator}
        setNumerator={setNumerator}
        denominatorAggregation={denominatorAggregation}
        setDenominatorAggregation={setDenominatorAggregation}
        denominator={denominator}
        setDenominator={setDenominator}
        decimalPlaces={decimalPlaces}
        setDecimalPlaces={setDecimalPlaces}
        description={description}
        setDescription={setDescription}
        filterConfig={filterConfig}
        setFilterConfig={setFilterConfig}
      />

      <div className="flex justify-between gap-x-2 pt-2">
        <Button
          onClick={() => setDisplayMode('create')}
          className="!w-1/2"
          variant="secondary"
        >
          {L.admin_panel.dashboards.cancel}
        </Button>
        <Button
          onClick={saveMetricComponent}
          isDisabled={!isFormStateValid}
          className="!w-1/2"
        >
          {L.admin_panel.dashboards.save}
        </Button>
      </div>
    </div>
  );
};
